import { domainService } from './src/domain/services/domainService';
import { oneTrustConsentService } from './src/domain/services/consentService/oneTrustConsentService';
import { googleTagManager } from './src/domain/services/googleTagManagerService';
import { conf, getHostConfig } from './src/domain/services/configService';
import { gptService } from './src/domain/services/gptService';
import { addScript } from './src/domain/utils/domUtils';

const setupRawConfig = async () => {
  if (!window.NATGEO_RAW_CONFIG) {
    let rawConfig = {};
    const hostConfig = getHostConfig();
    if (
      hostConfig.isPreview &&
      !domainService.isLocalDevDomain(window.location.hostname)
    ) {
      rawConfig = await fetch(
        `/preview-data/${
          window.NATGEO_LANGCODE
        }/custom/config/raw-config.json?${Date.now()}`
      ).then(response => response.text());
    } else {
      rawConfig = await fetch(
        `/config/raw-config.json?${window.NATGEO_CONFIG_HASH}`
      ).then(response => response.text());
    }
    window.NATGEO_RAW_CONFIG = rawConfig;
  }
  return window.NATGEO_RAW_CONFIG;
};

export const onClientEntry = new Promise((resolve, reject) => {
  // window._satellite = { track: () => {} };

  // DO NOT DELETE. It's used in some Blank Templates.
  // Ask Ricardo Baldo about it.
  window.___GAM = true;

  // Add dom util to insert scripts on DOM, used by Blank Templates.
  window.___ngAddScript = addScript;

  // Init GPT and enable its service before slots are defined
  // and display is called.
  gptService.init();

  setupRawConfig().then(rawConfig => {
    if (rawConfig) {
      resolve(rawConfig);
    } else {
      reject(new Error('No rawConfig available'));
    }
  });
});

// Called when the initial render of App is *done* on the client.
export const onInitialClientRender = () => {
  // Listen for OneTrustInteractionDone
  gptService.registerEventListeners();
  googleTagManager.registerEventListeners();
  oneTrustConsentService.listenToChanges();

  // Countries with CMP (GDPR) and with or without IAB.
  if (conf.activate_cmp) {
    oneTrustConsentService.setupOptanonWrapper();
    oneTrustConsentService.addScript();
  }
  // Countries without CMP (GDPR).
  else {
    oneTrustConsentService.dispatchCmpRequirementsReady();
    oneTrustConsentService.dispatchInteractionDone();
  }

  if (conf.bundle_code_custom_js) {
    try {
      // oxlint-disable-next-line no-eval
      eval(conf.bundle_code_custom_js);
    } catch (error) {
      // oxlint-disable-next-line no-console
      console.log('Error on bundle_code_custom_js:', error);
    }
  }
};
